import { ResidenceParamSegment } from './parseResidenceParamSegments';

type ResidenceParamLabelType = 'floors' | 'apartments';

export type ResidenceParamLabel = {
  key: string;
  options?: Record<string, string>;
};

const LABEL_KEYS: Record<
  ResidenceParamLabelType,
  {
    plain: string;
    numbered: string;
    named: string;
    ranged: string;
  }
> = {
  floors: {
    plain: 'residences.floors_per_building',
    numbered: 'residences.floors_per_building_numbered',
    named: 'residences.floors_per_building_named',
    ranged: 'residences.floors_per_buildings_ranged'
  },
  apartments: {
    plain: 'residences.apartments_per_floor_single',
    numbered: 'residences.apartments_per_floor',
    named: 'residences.apartments_per_floor_named',
    ranged: 'residences.apartments_per_floors'
  }
};

const isLetterName = (value: string) => /^[A-Za-z]/.test(value);

export const formatResidenceParamLabel = (
  { floor, range }: Pick<ResidenceParamSegment, 'floor' | 'range'>,
  type: ResidenceParamLabelType
): ResidenceParamLabel => {
  const keys = LABEL_KEYS[type];

  if (range) {
    return { key: keys.ranged, options: { range } };
  }

  if (floor != null) {
    if (isLetterName(floor)) {
      return { key: keys.named, options: { name: floor } };
    }

    return { key: keys.numbered, options: { label: floor } };
  }

  return { key: keys.plain };
};
